module.exports = __webpack_public_path__ + "img/ch16_03_若依犹豫.6df65362.jpg";